module.exports = __webpack_public_path__ + "officialStatic/img/ynjiLogo.553c086.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/ynjiLogo.png
// module id = O3L4
// module chunks = 0